import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { FIELD_NAME, PERCENT_NAME, SEPARATOR } from '../../config';

import type { TCallToAction } from './models';

export const CallToAction: FC<React.PropsWithChildren<TCallToAction>> = props => {
    const {
        Text,
        callToActionFinalText,
        callToActionText,
        maxValue,
        placeholder = '',
        progressBarFilledValue,
        progressBarValue = '',
        styles,
    } = props;

    /** Обертка результата */
    const Result: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
        <Text
            className={cn(styles.external, styles.callToActionText)}
            styler={{ marginTop: 8 }}
            tag="div"
        >
            {children}
        </Text>
    );

    // Если все поля с весом для прогресс-бара заполнены без ошибок.
    if (maxValue === progressBarFilledValue && callToActionFinalText) {
        return <Result>{callToActionFinalText}</Result>;
    }

    /*
     * TODO: В некоторых формах вместо мобильной версии вызывается десктопная,
     *  в которой этот элемент не отображается, из-за отсутствия полей
     *  callToActionText или placeholder. Этого нет в дизайне и нужно искоренить
     */
    if (!callToActionText || !placeholder) {
        return null;
    }

    // Иначе имеется незаполненное поле с весом
    const resultText = callToActionText.split(SEPARATOR);

    const hasBindField = resultText.indexOf(FIELD_NAME);
    const hasBindPercent = resultText.indexOf(PERCENT_NAME);
    const hasBoundText = hasBindField !== -1 && hasBindPercent !== -1;

    // Если есть вставки для названия поля и процента
    if (hasBoundText) {
        resultText.splice(hasBindField, 1, placeholder);
        resultText.splice(hasBindPercent, 1, progressBarValue.toString());

        return <Result>{resultText}</Result>;
    }

    // Иначе показать процент, текст и placeholder
    return (
        <Result>
            <Text tag="span" view="accent-component-primary">
                +{progressBarValue}%
            </Text>{' '}
            {callToActionText} {placeholder}
        </Result>
    );
};
